/**
 * Select the appropriate logging endpoint based on environment
 * All environments use Render-hosted logging services
 */
function getBaseLoggingUrl() {
  const host = window.location.hostname;
  if (host.includes("dev.endpointhealth.ca")) return "https://audit-logger-dev.onrender.com";
  if (host.includes("uat.endpointhealth.ca")) return "https://audit-logger-uat.onrender.com";
  if (host.includes("launch.endpointhealth.ca")) return "https://audit-logger-prd.onrender.com";
  return "https://audit-logger-dev.onrender.com";
}

const BASE_URL = getBaseLoggingUrl();
const LOG_URL = `${BASE_URL}/log`;
const PRO_URL = `${BASE_URL}/pro`;

/**
 * Log a FHIR AuditEvent by POSTing to the logging server
 * @param {object} auditEvent - a FHIR AuditEvent resource
 * @param {object} store - Redux store instance
 */
export async function logEvent(auditEvent, store) {
  const accessToken = store.getState().config.authToken;
  console.log("Logging AuditEvent:", auditEvent);
  console.log("Logging to URL:", LOG_URL);
  console.log("Using access token:", accessToken);

  if (!auditEvent?.resourceType || auditEvent.resourceType !== "AuditEvent") {
    console.warn("⚠️ Invalid resource passed to logEvent");
    return;
  }

  if (!accessToken) {
    console.warn("⚠️ Missing access token for audit logging");
    return;
  }

  try {
    const response = await fetch(LOG_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      },
      body: JSON.stringify(auditEvent)
    });

    if (!response.ok) {
      console.warn("❌ Audit log failed:", response.status);
    } else {
      console.log("✅ AuditEvent logged successfully");
    }
  } catch (e) {
    console.warn("⚠️ Failed to log AuditEvent:", e);
  }
}

/**
 * Log provider metadata by POSTing to the /pro endpoint
 * @param {object|object[]} providerData
 * @param {object} store - Redux store instance
 */
export async function logProvider(providerData, store) {
  const accessToken = store.getState().config.authToken;
  console.log("Logging provider data:", providerData);
  console.log("Logging to URL:", PRO_URL);
  console.log("Using access token:", accessToken);

  if (!providerData || (Array.isArray(providerData) && providerData.length === 0)) {
    console.warn("⚠️ No provider data to log");
    return;
  }

  if (!accessToken) {
    console.warn("⚠️ Missing access token for provider logging");
    return;
  }

  try {
    const response = await fetch(PRO_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      },
      body: JSON.stringify(providerData)
    });

    if (!response.ok) {
      console.warn("❌ Provider log failed:", response.status);
    } else {
      console.log("✅ Provider data logged successfully");
    }
  } catch (e) {
    console.warn("⚠️ Failed to log provider data:", e);
  }
}